// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ei-0";
export var actionModalContentContainer = "_ei-1";
export var createTagButton = "_ei-2";
export var footerContainer = "_ei-7";
export var fullWidthDivider = "_ei-3";
export var hasCreateTagButton = "_ei-4";
export var noCreateTagButton = "_ei-5";
export var tagsContainer = "_ei-6";
export var tagsModalContentContainer = "_ei-8";